// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalPage_root__raH2h","closeButton":"ModalPage_closeButton__hgDX7","header":"ModalPage_header__54Piw","body":"ModalPage_body__T7pco","footer":"ModalPage_footer__musI7"};